export class TaskDayScheduleTabMembership {
	public index;

	constructor(obj) {
		this.index = obj.index;
	}
} 
